module.exports = __webpack_public_path__ + "img/tail-spin-white.1655b029.svg";